import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UtilityService } from '../utility.service';
import { BaseFormService } from '../BaseFormService';
import { environment } from 'environments/environment';

@Injectable({
	providedIn: 'root',
})
export class OutOfCountyTravelAdjustmentFormService extends BaseFormService {
	constructor(httpClient: HttpClient, utilityService: UtilityService) {
		super(
			`${environment.apiUrl}forms/clients/$$clientId$$/out-of-county-travel-adjustment`,
			httpClient,
			utilityService
		);
	}
	getEmployeeForm(clientId: string, employeeId: string): Observable<any> {
		return this.httpClient.get(
			`${environment.apiUrl}forms/clients/${clientId}/out-of-county-travel-adjustment/employee/${employeeId}`
		);
	}
	getSlipForm(clientId: string, formId: string): Observable<Blob> {
		return this.httpClient.get<Blob>(
			`${environment.apiUrl}forms/clients/${clientId}/out-of-county-travel-adjustment/slip/${formId}`,
			{ responseType: 'blob' as 'json' }
		);
	}
	updateAutoPay(clientId: string, formId: string, autoPay: boolean): Observable<any> {
		return this.httpClient.patch(`${this.getUrl(clientId)}/${formId}/autopay`, autoPay).pipe();
	}
}
